import { Navigate, Outlet } from 'react-router-dom';

import { useAuth } from './AuthContext';

export const RoutesUser = () => {
    const { auth } = useAuth();

    return (
        auth.currentUser && auth.currentUser.emailVerified ?
            <Outlet /> :
            <Navigate to="/login" />
    );
}